// extracted by mini-css-extract-plugin
export default {"textContainer":"ListingNotFound_textContainer__m2wA1","title":"ListingNotFound_title__WSoFb","text":"ListingNotFound_text__vsa8H"};